import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-[#0B1120] flex items-center justify-center px-6 pt-24 pb-16">
      <Reveal>
        <div
          data-testid="payment-cancel-panel"
          className="max-w-lg w-full bg-[#0F172A] border border-white/10 p-10 text-center"
        >
          <XCircle size={56} className="text-slate-500 mx-auto mb-6" />
          <h1 className="font-display font-semibold text-white text-3xl mb-3">
            Payment cancelled<span className="text-[#ED1C24]">.</span>
          </h1>
          <p className="text-slate-400 text-sm leading-relaxed mb-8">
            No charge was made. Your cart is still saved — you can return to
            checkout whenever you're ready.
          </p>
          <div className="flex gap-3">
            <Link
              data-testid="cancel-back-checkout-btn"
              to="/checkout"
              className="flex-1 bg-[#ED1C24] hover:bg-[#C81016] text-white font-medium py-3.5 transition-colors duration-300"
            >
              Back to Checkout
            </Link>
            <Link
              data-testid="cancel-back-shop-btn"
              to="/shop"
              className="flex-1 border border-white/15 hover:border-[#ED1C24] text-slate-300 py-3.5 text-sm transition-colors duration-300 flex items-center justify-center"
            >
              Back to Shop
            </Link>
          </div>
        </div>
      </Reveal>
    </main>
  );
}
